const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_OED9Yo5uL",
    "aws_user_pools_web_client_id": "m8jfrkd049qmrcq92hel1j6nu",
    "oauth": {
        "domain": "daizika.auth.us-east-1.amazoncognito.com",
        "scope": [
            "aws.cognito.signin.user.admin",
            "email",
            "openid",
            "phone",
            "profile"
        ],
        "redirectSignIn": "https://webapp.daizika.com/",
        "redirectSignOut": "https://webapp.daizika.com/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS"
};

export default awsmobile;
